import bilAPI from "../api";

export const deleteTeamMember = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/olympiad/team_members/${uuid}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchTeamMember = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/olympiad/team_members/${uuid}/edit_user_data/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postResetPasswordTeamMember = (teamMemberUuid, email) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/team_members/${teamMemberUuid}/reset_password/`, {
          email: email,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postDistributeSeats = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/olympiad/team_members/distribute_seats/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
